import { HIGHLIGHT_DELETE_INTENT_CLASS } from '@databases/highlights/constants';

import { createEffect } from '../utils/create-effect';

import { SELECTIONS_CONTAINER_ELEMENT_ID } from './constants';

export const createDeleteIntentHighlightEffect = createEffect(() => ({
  deltaTypes: ['previewSelectionAction'] as const,

  dispose() {
    document
      .getElementById(SELECTIONS_CONTAINER_ELEMENT_ID)
      ?.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
  },

  onDelta(delta) {
    const container = document.getElementById(SELECTIONS_CONTAINER_ELEMENT_ID);

    if (!container) {
      return;
    }

    if (delta.intent === 'delete') {
      container.classList.add(HIGHLIGHT_DELETE_INTENT_CLASS);
    } else {
      container.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
    }
  },
}));
